export default __webpack_public_path__ + "static/media/warning.fdffcf92.svg";